import React, { useState } from 'react';
import { X, Plus, Trash2, Briefcase } from 'lucide-react';
import { doc, setDoc, getDoc } from 'firebase/firestore'; // Changed to setDoc/getDoc for simpler settings management
import { db } from '../../firebase/config';

const ManageRolesModal = ({ isOpen, onClose, currentUserProfile, currentRoles, onRolesUpdated }) => {
    const [newRole, setNewRole] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    if (!isOpen) return null;

    const handleAddRole = async () => {
        if (!newRole.trim()) return;
        const updatedRoles = [...currentRoles, newRole.trim()];
        await saveRoles(updatedRoles);
        setNewRole('');
    };

    const handleDeleteRole = async (roleToDelete) => {
        const updatedRoles = currentRoles.filter(role => role !== roleToDelete);
        await saveRoles(updatedRoles);
    };

    const saveRoles = async (roles) => {
        setIsSaving(true);
        try {
            // We store this in a specific 'settings' document for hiring
            const settingsRef = doc(db, `organizations/${currentUserProfile.organizationId}/settings`, 'hiring');
            await setDoc(settingsRef, { roles: roles }, { merge: true });
            onRolesUpdated(roles); // Update parent state immediately
        } catch (error) {
            console.error("Error saving roles:", error);
            alert("Failed to save roles.");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
                <div className="flex justify-between items-center p-4 border-b">
                    <h2 className="text-xl font-bold flex items-center gap-2">
                        <Briefcase size={20} className="text-blue-600"/> 
                        Manage Open Roles
                    </h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <X size={24} />
                    </button>
                </div>

                <div className="p-6">
                    {/* Add New Role Input */}
                    <div className="flex gap-2 mb-6">
                        <input 
                            type="text" 
                            value={newRole}
                            onChange={(e) => setNewRole(e.target.value)}
                            placeholder="e.g. Senior Plumber"
                            className="flex-1 p-2 border rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                        <button 
                            onClick={handleAddRole}
                            disabled={isSaving || !newRole.trim()}
                            className="bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                        >
                            <Plus size={20} />
                        </button>
                    </div>

                    {/* Role List */}
                    <div className="space-y-2 max-h-60 overflow-y-auto">
                        {currentRoles.length === 0 && <p className="text-gray-500 text-center italic">No roles defined yet.</p>}
                        
                        {currentRoles.map((role, index) => (
                            <div key={index} className="flex justify-between items-center p-3 bg-gray-50 rounded-md border">
                                <span className="font-medium text-gray-700">{role}</span>
                                <button 
                                    onClick={() => handleDeleteRole(role)}
                                    className="text-gray-400 hover:text-red-600"
                                >
                                    <Trash2 size={16} />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageRolesModal;